export const PRODUCT_TYPE_QUOTATION_PROPOSAL = 4;
export const PRODUCT_TYPE_SHARED_FLIGHT = 2;
export const PRODUCT_TYPE_EMPTY_LEG = 3;
